import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { format } from 'date-fns';

const STATUS_BADGE = {
  draft:'badge-gray', submitted:'badge-amber', mgr_approved:'badge-blue',
  hr_approved:'badge-teal', client_approved:'badge-green', rejected:'badge-red', needs_revision:'badge-amber'
};

export default function Dashboard() {
  const { user } = useAuth();
  const [data, setData] = useState({ employees:0, projects:0, pending:[], stats:{} });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isHR = user?.role === 'hr';
    const calls = isHR
      ? [api.get('/employees'), api.get('/projects'), api.get('/timesheets?status=submitted'), api.get('/timesheets?status=mgr_approved'), api.get('/timesheets?status=hr_approved')]
      : [api.get('/timesheets/team?status=submitted')];

    Promise.all(calls).then(res => {
      if (isHR) {
        setData({
          employees: res[0].data.employees.length,
          projects:  res[1].data.projects.filter(p=>p.status==='active').length,
          pending:   [...res[2].data.timesheets, ...res[3].data.timesheets, ...res[4].data.timesheets].slice(0,8),
          stats: { submitted: res[2].data.timesheets.length, mgr_approved: res[3].data.timesheets.length, hr_approved: res[4].data.timesheets.length },
        });
      } else {
        setData({ employees:0, projects:0, pending: res[0].data.timesheets.slice(0,8), stats:{ submitted: res[0].data.timesheets.length } });
      }
    }).finally(() => setLoading(false));
  }, [user]);

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Good morning, {user?.name?.split(' ')[0]} 👋</h1>
          <p className="page-sub">{format(new Date(),'EEEE, MMMM d yyyy')} · {user?.role === 'manager' ? 'Manager' : 'HR Admin'}</p>
        </div>
      </div>

      <div className="stats-grid">
        {user?.role === 'hr' && <>
          <div className="stat-card"><div className="stat-label">Employees</div><div className="stat-value" style={{color:'#6c63ff'}}>{data.employees}</div></div>
          <div className="stat-card"><div className="stat-label">Active Projects</div><div className="stat-value">{data.projects}</div></div>
        </>}
        <div className="stat-card"><div className="stat-label">Awaiting Manager</div><div className="stat-value" style={{color:'#f59e0b'}}>{data.stats.submitted || 0}</div></div>
        {user?.role === 'hr' && <>
          <div className="stat-card"><div className="stat-label">Awaiting HR</div><div className="stat-value" style={{color:'#3b82f6'}}>{data.stats.mgr_approved || 0}</div></div>
          <div className="stat-card"><div className="stat-label">Awaiting Client</div><div className="stat-value" style={{color:'#4ecdc4'}}>{data.stats.hr_approved || 0}</div></div>
        </>}
      </div>

      <div className="card">
        <h2 style={{fontSize:15,fontWeight:600,marginBottom:16}}>
          {user?.role === 'manager' ? 'Team Timesheets Pending Your Approval' : 'Recent Timesheet Activity'}
        </h2>
        {data.pending.length === 0 ? (
          <div className="empty"><div className="empty-icon">✅</div><p>All caught up!</p></div>
        ) : (
          <div className="table-wrap" style={{border:'none'}}>
            <table>
              <thead><tr><th>Employee</th><th>Week</th><th>Status</th><th>Submitted</th></tr></thead>
              <tbody>
                {data.pending.map(ts => (
                  <tr key={ts.id}>
                    <td><div className="flex items-center gap-2"><div className="avatar">{ts.employee?.name?.charAt(0)}</div><div><div className="fw-600">{ts.employee?.name}</div><div className="text-sm text-muted">{ts.employee?.department}</div></div></div></td>
                    <td>{format(new Date(ts.week_start),'MMM d, yyyy')}</td>
                    <td><span className={`badge ${STATUS_BADGE[ts.status]}`}>{ts.status.replace('_',' ')}</span></td>
                    <td className="text-sm text-muted">{ts.submitted_at ? format(new Date(ts.submitted_at),'MMM d, h:mm a') : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
